<template>
  <div>
    <div class="schedule" v-for="(item, index) in cards.length" :key="index">
      <div class="schedule_cards">
        <div class="schedule_cards-title">
          <validation-observer ref="simpleRules">
            <b-row>
              <b-col :cols="services.length > 0 ? '6' : '12'">
                <validation-provider
                  name="Schedule"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <Select2
                      placeholder="Please select type of schedule"
                      v-model="schedule_selected"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :state="errors.length > 0 ? false : null"
                      :options="schedules"
                    />
                    <small
                      v-if="services.length > 0 ? true : false"
                      class="text-danger"
                      >{{ errors[0] }}</small
                    >
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6" v-if="services.length > 0 ? true : false">
                <validation-provider
                  name="Services"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-group>
                    <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Please select type of services"
                      v-model="services_selected"
                      :options="services"
                    />
                      <small v-show="errors.length > 0" class="text-danger">{{
                        errors[0]
                      }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <!-- password -->
                <b-form-group>
                  <label class="pl-1">Origin Station </label>
                  <Select2
                    placeholder="Please select origin station"
                    v-model="pol"
                    :options="polList"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <!-- password -->
                <b-form-group>
                  <label class="pl-1">Destination Station</label>
                  <Select2
                    placeholder="Please select destination station"
                    v-model="pod"
                    :options="podList"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group>
                  <label class="pl-1">From Date</label>
                  <b-form-datepicker
                    class="round border-success border"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group>
                  <label class="pl-1">To Date</label>
                  <b-form-datepicker
                    class="round border-success border"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                    locale="vi-VN"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="pt-3">
              <b-col cols="12" class="text-center">
                <button class="btn btn-success round" @click="getSchedule">
                  <feather-icon icon="SearchIcon" class="cursor-pointer" />
                  {{ $t("search") }}
                </button>
              </b-col>
            </b-row>
          </validation-observer>
        </div>
      </div>
    </div>

    <b-row class="pt-2">
      <b-col cols="12" v-show="schedule_list.length > 0">
        <b-card title="Schedule list">
          <b-card-text>
            <b-table
              hover
              :striped="true"
              :bordered="true"
              responsive="sm"
              :items="schedule_list"
              :fields="fields"
            >
              <template #cell(actions)>
                <b-button variant="primary" size="sm" @click="href">
                  Find a Quotation
                </b-button>
              </template>
            </b-table>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
  BCardText,
  BButton,
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: ["cards"],
  components: {
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    BCardText,
    Select2,
    BButton,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      schedule_selected: null,
      services_selected: null,

      schedules: [
        { id: "SEA", text: "Sea" },
        { id: "AIR", text: "Air" },
        { id: "DOMESTIC", text: "Domestic" },
      ],
      services: [],
      pol: "",
      pod: "",
      polList: [],
      podList: [],

      services_options: {
        SEA: [
          { id: "LCL", text: "LCL SCHEDULE" },
          { id: "FCL", text: "FCL SCHEDULE" },
        ],
        DOMESTIC: [
          { id: "FTL", text: "FTL SCHEDULE" },
          { id: "LTL", text: "LTL SCHEDULE" },
        ],
        AIR: [],
      },

      schedule_list: [],
      fields: [
        {
          key: "voyageNo",
          sortable: true,
          label: "VOYAGE NO",
        },
        {
          key: "vesselName",
          sortable: true,
          label: "VESSEL NAME",
        },
        {
          key: "transitTime",
          sortable: true,
          label: "transitTime",
        },
        {
          key: "transitPort",
          label: "transitPort",
          sortable: true,
        },
        {
          key: "pol",
          label: "pol",
          sortable: true,
        },
        {
          key: "notes",
          label: "notes",
          sortable: true,
        },
        {
          key: "etd",
          label: "etd",
          sortable: true,
        },
        {
          key: "destination",
          label: "destination",
          sortable: true,
        },
        {
          key: "carrierName",
          label: "carrierName",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          class: "text-center",
        },
      ],
    };
  },
  methods: {
    async getSchedule() {
      var validate = await this.$refs.simpleRules[0]
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "THIS FIELD IS REQUIRED!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      useJwt
        .get(
          `get-schedule?type=${this.schedule_selected}&transitPort=&pol=${this.pol}&pod=${this.pod}&serviceName=${this.services_selected}`,
          {}
        )
        .then((response) => {
          const data = response.data.result;

          const mapData = data.map((obj) => {
            obj.actions = "/user/find-a-quotation";

            return obj;
          });
          this.schedule_list = mapData;
          return;
        });
    },
    href() {
      this.$router.push("/user/find-a-quotation");
    },
  },
  mounted() {},
  watch: {
    schedule_selected() {
      useJwt
        .get(`prepare-check-schedule?type=${this.schedule_selected}`, {})
        .then((response) => {
          const dataPolList = response.data.result.polList;
          const dataPodList = response.data.result.podList;
          const mapPolList = dataPolList.map((obj) => {
            obj.text = obj.text || obj.portName;
            obj.id = obj.id || obj.portCode;
            return obj;
          });
          const mapPodList = dataPodList.map((obj) => {
            obj.text = obj.text || obj.portName;
            obj.id = obj.id || obj.portCode;
            return obj;
          });
          this.polList = mapPolList;
          this.podList = mapPodList;
        });

      if (this.schedule_selected) this.services = [];
      this.services.push(...this.services_options[this.schedule_selected]);
    },
  },
};
</script>
<style>
.schedule .vue-dropzone > .dz-preview .dz-details {
  background: #2b938c;
}
.schedule .dropzone {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}
.schedule .select2-selection--single {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}
.schedule .select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}
.schedule .select2-selection__arrow {
  background: none;
  display: none !important;
}
</style>
<style lang="scss" scoped>
@media (max-width: 1024px) {
  .table-responsive-sm {
    overflow: hidden;
    overflow-x: scroll;
  }
  .card {
    overflow: hidden;
  }
}
.booking-online-footer {
  background: #f8f7f7;
  div {
    margin: auto;
    padding: 20px 0px;
    text-align: center;
    max-width: 559px;
  }
}
.schedule {
  position: relative;
  @media (min-width: 900px) {
    &:nth-child(1) {
      &::after {
        content: "";
        position: absolute;
        top: 36%;
        transform: translate(0, -50%);
        right: -110px;
        background-image: url("../../../../../assets/images/core-service/core-top.svg");
        background-repeat: no-repeat;
        background-size: 280px 280px;
        display: inline-block;
        width: 280px;
        height: 280px;
      }
      &::before {
        content: "";
        position: absolute;
        bottom: 110px;
        left: -120px;
        background-image: url("../../../../../assets/images/core-service/core-bottom.svg");
        background-repeat: no-repeat;
        background-size: 260px 260px;
        display: inline-block;
        width: 260px;
        height: 260px;
      }
    }
  }
  @media (min-width: 320px) {
    padding: 10px;
  }
  @media (min-width: 900px) {
    padding: 40px 70px;
  }
  @media (min-width: 1024px) {
    padding: 40px 250px;
  }
  @media (min-width: 1900px) {
    padding: 100px 470px;
  }

  &_cards {
    padding-left: 0;
    &-title {
      color: var(--text-normal-color);
      font-style: var(--normal-font-size);
      font-weight: 400;
      // margin-bottom: 80px;
    }
    &-blog-card {
      display: flex;
      align-items: center;
      gap: 50px;
      flex-direction: column;
      @media (min-width: 900px) {
        flex-direction: row;
      }

      &-text {
        order: 2;
        flex: 0 0 50%;
        padding: 30px;
        padding-top: 130px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        &-title {
          color: var(--primary-color);
          font-style: var(--big-font-size);
          font-weight: 700;
        }
        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
        }
      }
      &-meta {
        flex: 0 0 50%;
        order: 1;
        &-photo {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>